let cachedRules: any[] | null = null;
let lastFetchTime: number = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const getPriceForDate = (date: Date): number => {
  if (!cachedRules) {
    console.warn("No cached pricing rules available, using default price");
    return 120;
  }

  // Нормализираме датата за сравнение (премахваме часовете, минутите и секундите)
  const normalizedDate = new Date(date);
  normalizedDate.setHours(0, 0, 0, 0);

  const applicableRule = cachedRules.find((rule) => {
    const startDate = new Date(rule.startDate);
    const endDate = new Date(rule.endDate);

    // Нормализираме и датите от правилата
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    // Сравняваме само месеца и деня, игнорирайки годината
    const dateMonth = normalizedDate.getMonth();
    const dateDay = normalizedDate.getDate();

    const startMonth = startDate.getMonth();
    const startDay = startDate.getDate();

    const endMonth = endDate.getMonth();
    const endDay = endDate.getDate();

    // Проверка дали датата е в диапазона
    if (dateMonth === startMonth && dateMonth === endMonth) {
      return dateDay >= startDay && dateDay <= endDay;
    } else if (dateMonth === startMonth) {
      return dateDay >= startDay;
    } else if (dateMonth === endMonth) {
      return dateDay <= endDay;
    } else {
      return dateMonth > startMonth && dateMonth < endMonth;
    }
  });

  return applicableRule ? applicableRule.price : 120;
};

export const fetchPricingRules = async (): Promise<void> => {
  const now = Date.now();
  if (cachedRules && now - lastFetchTime < CACHE_DURATION) {
    //console.log("Using cached rules");
    return;
  }

  try {
    //console.log("Fetching pricing rules from server...");
    // const response = await fetch("http://localhost:3331/api/pricing-rules");
    const response = await fetch(
      "https://api.nameren-rai.com/api/pricing-rules"
    );
    if (!response.ok) {
      throw new Error("Failed to fetch pricing rules");
    }
    const rules = await response.json();
    //console.log("Raw rules from server:", rules);

    // Ensure dates are properly parsed
    const parsedRules = rules.map((rule: any) => {
      const parsedRule = {
        ...rule,
        startDate: new Date(rule.startDate),
        endDate: new Date(rule.endDate),
      };
      return parsedRule;
    });

    //console.log("All parsed rules:", parsedRules);
    cachedRules = parsedRules;
    lastFetchTime = now;
  } catch (error) {
    console.error("Error fetching pricing rules:", error);
    if (!cachedRules) {
      cachedRules = [];
    }
  }
};
